<div id="pano" class="pano"></div>

<ng-container class="scene__pointers" *ngIf="scenesLinks[currentIndex]?.pointers">
  <div
    *ngFor="let pointer of (scenesLinks[currentIndex].pointers || []);let index = index"
    class="scene__pointers__item"
    id="pointer-{{currentIndex}}-{{index}}"
    (click)="loadScene($event, pointer.next)"
    (mousedown)="onMouseDown($event)">
    <app-pointer [size]="pointer.size" [name]="pointer?.name"></app-pointer>
</div>
</ng-container>

<div class="scene__frames" *ngIf="scenesLinks[currentIndex]?.frames">
  <div
          *ngFor="let frame of (scenesLinks[currentIndex].frames || []);let index = index"
          id="frame-{{currentIndex}}-{{index}}"
          (mousedown)="onMouseDown($event)"
          (click)="loadFrame($event, frame)"
  >
    <app-frame [frame]="frame"></app-frame>
  </div>
</div>

<div class="loading" [class.hide]="hideLoading"></div>

<!--<app-center-->
<!--  [view]="view"-->
<!--&gt;</app-center>-->

<app-navbar></app-navbar>

<app-floor></app-floor>
